











import Vue from 'vue'
import Header from '../components/Header/Header.vue';

export default Vue.extend({
    components: {
        Header
    }
})
